import { memo } from "react";
import TextRollup from "../TextRollup";
import styles from "./loaderBre.module.scss";

export const LoaderBRE = memo(({loading}) => {
    const msg = ["Finding the best offer for you...", "Almost there, Standby...", "Getting Best loan tenure...", "We’re almost there, hang tight!", "Checking your eligibility...", "Reviewing your details securely..."];
    return <div className={`${styles.breLoader} ${loading ? styles.showLoader : ''}`} >
        <div className={styles.loaderContainer} >
            <div className={styles.loader}>
                <img src="/images/bre-loader.gif" />
                <div>
                    <TextRollup items={msg}
                    hold={3000}
                    move={600}
                    lineHeight="2.5rem" />
                </div>
            </div>
            <div className={styles.bmsg} >
                don’t exit the screen or press back <br />
                this could take up to <span className={styles.mark}>115 seconds</span>
            </div>
        </div>
    </div>
});